export const viewportSizesList = [
  {
    name: "SMALL",
    maxValue: 575
  },
  {
    name: "MEDIUM",
    minValue: 576,
    maxValue: 991
  },
  {
    name: "LARGE",
    minValue: 992,
    maxValue: 1199
  },
  {
    name: "EXTRA_LARGE",
    minValue: 1200
  }
];
export const viewportSizeOrder = {
  "UNKNOWN": -1,
  "SMALL": 0,
  "MEDIUM": 1,
  "LARGE": 2,
  "EXTRA_LARGE": 3
};
export const viewportSizes = Object.fromEntries(viewportSizesList.map((s) => [s.name, s]));
function matchViewportSize(width, viewportSize) {
  if (viewportSize.minValue && viewportSize.maxValue) {
    return width >= viewportSize.minValue && width < viewportSize.maxValue;
  } else if (viewportSize.minValue && !viewportSize.maxValue) {
    return width >= viewportSize.minValue;
  } else if (!viewportSize.minValue && viewportSize.maxValue) {
    return width < viewportSize.maxValue;
  }
}
export function getViewportSize() {
  const width = window.innerWidth;
  return {
    viewportSize: viewportSizesList.find((s) => matchViewportSize(width, s))?.name ?? "UNKNOWN",
    width
  };
}
